import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SequenceEventFormComponent } from '@app/components/forms/sequence-event/form.component';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { SequenceEvent, SequenceEventCreate } from '@app/models/sequence-event.interface';
import { SequenceEventHelperService } from '@app/services/helpers/sequence-event-helper.service';
import { ToastService } from '@app/services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-sequence-event-edit',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        SequenceEventFormComponent,
        FontAwesomeModule,
        RouterModule,
    ],
    templateUrl: './edit.page.html',
    styleUrl: './edit.page.scss'
})
export class SequenceEventEditPage {
  public title = 'Sequence Event Edit';
  formValid = signal(false);
  formValue = signal<SequenceEventCreate | null>(null);
  id: number;
  sequenceEvent$: Observable<SequenceEvent>;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private sequenceEventHelper: SequenceEventHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.sequenceEvent$ = this.sequenceEventHelper.getById(this.id);
  }

  update() {
    let val = this.formValue();
    if(val)
      this.sequenceEventHelper.update(this.id, val).subscribe({
        next: (success) => { this.router.navigate(['sequence-events', this.id]); },
        error: (err: AppHttpError) => {
          this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
        }
      });
  }
}
